import React from 'react'
import Pane from 'components/Common/Pane'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  className?: string;
}

function LastMinuteSummary(props: Props) {
  const {
    className,
  } = props

  return (
    <Pane
      border="neutral-six"
      borderRadius="XS"
      padding="28 20"
      shadow="bottom-small"
      className={className}
      data-testid="SummaryPane"
    >
      <VerticalSpacer gap={12}>
        <BodyText
          variant="large"
          data-testid="OfferSoldOut"
          weight="bold"
        >
          This offer has SOLD OUT
        </BodyText>
        <TextButton
          kind="primary"
          to="/"
          fit="flex"
        >
          Browse all offers
        </TextButton>
      </VerticalSpacer>
    </Pane>
  )
}

export default LastMinuteSummary
